<template>
  <header>
    <ModalVideoCall @disable="(vl) => modalVideoCall = vl"
    :showModalVideoCall="modalVideoCall"/>
    <div :class="$style.header">
      <div :class="$style.subHeader">
        <div :class="$style.subContent" @click="redirect('https://www6.cuprum.cl/sucursales');">
          <div :class="$style.subContentImg">
            <img src="~@/assets/images/globe.svg" />
          </div>
          <div>
            <b>Sucursales</b>
          </div>
        </div>
        <div :class="$style.subContent" @click="redirect('https://www6.cuprum.cl/haz-tu-consulta-o-reclamo');">
          <div :class="$style.subContentImg">
            <img src="~@/assets/images/mail.svg" />
          </div>
          <div>
            <b>Contáctanos</b>
          </div>
        </div>
      </div>
      <div :class="$style.content">
        <div :class="$style.logoCuprum" @click="changeMenu('home')">
          <img
            loading="lazy"
            src="@/assets/images/Cuprum_Logo_Positivo.svg"
            width="150"
            alt="Logo de Cuprum AFP"
          />
        </div>
        <div :class="$style.textHeader">
          <div :class="selectedMenu === '/home' && !modalVideoCall ? $style.home : $style.homeFalse"
          @click="changeMenu('home')">
            <img
              src="~@/assets/images/Home.svg"
              :class="[$style.icon, $style.homeIcon]" />
          </div>
          <div v-for="(tipo, index) in menu" :key="index">
            <div @click="changeMenu(tipo.path)">
              <PdsLink
                link="javascript:;"
                :text="tipo.name"
                :class="selectedMenu === tipo.path && !modalVideoCall
                ? $style.link
                : $style.linkFalse"
                />
            </div>
          </div>
          <div v-if="buttonModalVideoCall" :class="$style.videoCall" @click="openModal()">
            <div :class="$style.videoCall">
              <PdsButton :class="$style.videoCallButton"  label="Nuevo" />
              <PdsLink
                link="javascript:;"
                text="Cambio de fondo"
                :class="modalVideoCall ? $style.link : $style.linkFalse"
                />
            </div>
          </div>
          <div :class="$style.userDiv">
            <div :class="[$style.divClose, $style.linkFalse]" @click="closeSession();">
              <PdsIcon
                name="log-out"
                fill="#0061a0"
                isPointer
                :class="$style.icon" />
              <PdsLink
                link="javascript:;"
                text="Cerrar sesión"
                :class="$style.linkClose" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.mobile">
      <div :class="$style.contentDisplay">
        <div :class="$style.icons" @click="visibleMenu();">
          <img
            loading="lazy"
            src="@/assets/images/menu.svg"
            width="25"
          />
        </div>
        <div>
          <img
            loading="lazy"
            src="@/assets/images/Logo_Cuprum.svg"
            width="150"
            alt="Logo de Cuprum AFP"
          />
        </div>
        <div :class="$style.icons" @click="visibleMenuUser();">
          <img
            loading="lazy"
            src="~@/assets/images/user_white.svg"
            :class="$style.icon"
            width="25"
            alt="Logo de Cuprum AFP"
          />
        </div>
      </div>
    </div>
    <div :class="[$style.blockScreen,
      menuVisible || menuVisibleUser ? $style.menuShow : $style.menuHide]"></div>
    <div :class="[$style.menuMobile, menuVisible ? $style.menuShow : $style.menuHide]">
      <div :class="$style.closeMenu" @click="visibleMenu();">
        <div>
          <img
            loading="lazy"
            src="@/assets/images/x.svg"
            width="20"
            :class="$style.imgCloseMenu"
          />
        </div>
        <div :class="$style.textCloseMenu">
          Cerrar menú
        </div>
      </div>
      <div>
        <div v-for="(tipo, index) in menu" :key="index">
          <div @click="changeMenu(tipo.path)" :class="$style.textMenuMobile">
            {{ tipo.name }}
          </div>
        </div>
      </div>
      <div v-if="buttonModalVideoCall" :class="$style.textMenuMobile" @click="openModal()">
        Cambio de fondo
        <PdsButton :class="$style.videoCallButtonMobile"  label="Nuevo" />
      </div>
    </div>
    <div :class="[$style.menuMobileUser,
      menuVisibleUser ? $style.menuShow : $style.menuHide]">
      <div :class="$style.closeMenuUser" @click="visibleMenuUser();">
        <div :class="$style.textMenuUser">
          Hola, {{ nameBeneficiary }}
        </div>
        <img
          loading="lazy"
          src="@/assets/images/x.svg"
          width="20"
          :class="$style.imgCloseMenu"
        />
      </div>
      <div :class="$style.borderClose"></div>
      <div :class="$style.closeSessionUser" @click="closeSession();">
        <PdsIcon
          name="log-out"
          fill="#0061a0"
          isPointer />
        <div :class="$style.textCloseSession">
          Cerrar sesión
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import PdsLink from '@vue-pds/link';
import PdsIcon from '@vue-pds/icon';
import PdsButton from '@vue-pds/button';
import { mapGetters, mapState } from 'vuex';
import { capitalize } from '@/includes/formatters';
import types from '@/constants/types';
import gtmRegister from '@/functions/analitics';
import constantsAnalytics from '@/config/constantsAnalytics';
import ModalVideoCall from '@/components/ModalVideoCall';

export default {
  name: 'Header',
  components: {
    PdsLink,
    PdsIcon,
    PdsButton,
    ModalVideoCall,
  },
  data() {
    return {
      selectedMenu: '/home',
      nameBeneficiary: '',
      menu: this.$router.options.routes.filter((menu) => {
        if (menu.type === 'menu') {
          if (!this.$store.state.async[types.async.GET_VALIDATE_BENEFICIARY].data.data.enabled && menu.nameWidget === 'details') {
            return null;
          }
          return menu;
        }
        return null;
      }),
      userMenu: false,
      menuVisible: false,
      menuVisibleUser: false,
      modalVideoCall: false,
      buttonModalVideoCall: false,
    };
  },
  mounted() {
    this.buttonModalVideoCall = this.validateBeneficiaryData.data.enabled;
  },
  methods: {
    changeMenu(selected) {
      this.selectedMenu = selected;
      this.menuVisible = false;
      this.$router.push({ path: selected });
    },
    openMenu() {
      this.userMenu = true;
    },
    closeSession() {
      gtmRegister(constantsAnalytics.site.logout, this);
      this.$router.push('/');
    },
    visibleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    visibleMenuUser() {
      this.menuVisibleUser = !this.menuVisibleUser;
    },
    redirect(ruta) {
      window.open(ruta, '_blank');
    },
    openModal() {
      this.menuVisible = false;
      this.modalVideoCall = true;
    },
  },
  computed: {
    ...mapGetters({
      names: 'getNames',
    }),
    ...mapState({
      validateBeneficiaryData: state => state.async[types.async.GET_VALIDATE_BENEFICIARY].data,
    }),
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    '$route'(to) {
      this.selectedMenu = to.path;
    },
  },
  created() {
    this.nameBeneficiary = capitalize(this.names, true);
  },
};
</script>

<style lang="scss" module>
.hLine {
  width: 100%;
  height: 3px;
  margin: 0;
  background: #0061a0;
  border: 0;
}

.hLineHome {
  width: 100%;
  height: 3px;
  margin: -1.6px 0 0 0;
  background: #0061a0;
  border: 0;
}

.hLineFalse {
  margin: 0;
  visibility: hidden;
  border: 0;
}

.link {
  padding: 0 20px 4.4px 20px;
  font-size: 1rem;
  line-height: 1.75rem;
  color: #333333;
  border-bottom: 3px solid #0061a0;
}

.link:hover {
  border-bottom: 3px solid #002e6d;
}

.linkFalse {
  height: 31px;
  padding: 0 20px 4.4px 20px;
  font-size: 1rem;
  line-height: 1.75rem;
  color: #333333;
  border-bottom: 0;
}

.linkFalse:hover {
  border-bottom: 3px solid #002e6d;
}

.divClose {
  display: flex;
  margin-right: 40px;
  cursor: pointer;

  .linkClose {
    margin-left: 8px;
    font-size: 1rem;
    line-height: 1.75rem;
    color: #333333;
    border-bottom: 0;
  }
}

.homeIcon {
  cursor: pointer;
}

.videoCall {
  display: flex;
  justify-content: center;
}

.videoCallButton {
  position: absolute;
  top: 35px;
  display: flex;
  justify-content: center;
  width: 59px;
  padding: 5px !important;
  font-size: 14px !important;
  border-radius: 5px !important;
}

.videoCallButtonMobile {
  display: flex;
  justify-content: center;
  width: 59px;
  padding: 5px !important;
  font-size: 14px !important;
  border-radius: 5px !important;
}

.header {
  width: 100%;
  border-bottom: #f4b233 solid 3px;

  & .subHeader {
    display: flex;
    justify-content: flex-end;
    height: 25px;
    font-size: 0.9rem;
    text-align: end;
    background-color: #0061a0;

    & .subContent {
      display: flex;
      padding-top: 4px;
      margin-right: 35px;
      line-height: 15px;
      color: white;
      cursor: pointer;

      & .subContentImg {
        margin-right: 5px;
      }
    }
  }

  & .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 28px 0;

    & .logoCuprum {
      min-width: 50px;
      padding: 0 50px;
      cursor: pointer;
    }

    & .textHeader {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-top: 10px;

      & .userDiv {
        display: flex;
        margin-left: 20px;

        & .card {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: left;

          & .icon {
            padding-left: 15px;
          }

          & .linkUserMenu {
            height: 15px;
            font-size: 1.125rem;
            line-height: 1.75rem;
            color: #333333;
            border-bottom: 0;
          }
        }

        & .dropdown {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          height: auto;
          text-align: right;
          background-color: #ffffff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.253961);

          & .dropdownUser {
            padding-bottom: 35px;
            text-align: center;
          }

          & .hr {
            width: 150px;
            background: #c5c6c5;
          }

          & .link {
            padding: 5px 20px;
          }
        }
      }

      & .home {
        margin-right: 30px;
        cursor: pointer;
        border-bottom: 3px solid #0061a0;
      }

      & .home:hover {
        border-bottom: 3px solid #002e6d;
      }

      & .homeFalse {
        margin-right: 30px;
        cursor: pointer;
        border-bottom: 0;
      }

      & .homeFalse:hover {
        border-bottom: 3px solid #002e6d;
      }

      & div {
        height: 31px;

        & .icons {
          & .img {
            margin-right: 5px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

.mobile {
  display: none;
}

.blockScreen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}

.menuShow {
  display: block;
}

.menuHide {
  display: none;
}

.menuMobile {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 250px;
  height: 100%;
  background-color: white;

  .closeMenu {
    display: flex;
    margin: 45px 25px 25px;

    .imgCloseMenu {
      padding-top: 4px;
    }
  }

  .textCloseMenu {
    padding-top: 2px;
    margin-left: 5px;
  }

  .textMenuMobile {
    margin: 8px 25px;
  }
}

.menuMobileUser {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  width: 250px;
  height: 100%;
  background-color: white;

  .closeMenuUser {
    display: flex;
    margin: 45px 25px 25px;
  }

  .closeSessionUser {
    display: flex;
    margin: 25px;
  }

  .textMenuUser {
    margin-right: 5px;
  }

  .textCloseSession {
    margin-left: 5px;
  }

  .borderClose {
    margin: 0 35px;
    border-top: 1px solid #c5c6c5;
  }
}

@media (max-width: 1230px) {
  .header {
    & .subHeader {
      & .subContent {
        margin-right: 20px;
      }
    }

    & .content {
      & .logoCuprum {
        padding: 0 20px;
      }

      & .textHeader {
        padding: 10px 0 0 0;
      }
    }
  }

  .divClose {
    margin-right: 20px;
  }
}

@media (max-width: 767px) {
  .header {
    display: none;
  }

  .mobile {
    display: flex;
    height: 90px;
    background-color: #0061a0;

    & .contentDisplay {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
      width: 100%;
      margin: 0 10px;

      & .icons {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
